import { styled } from "@mui/material/styles";
import { Box, Chip, TextField, Button, Typography } from "@mui/material";

export const ChipActive = styled(Chip)({
  "&.MuiChip-root": {
    backgroundColor: "transparent",
    color: "#4caf50",
    border: "1px solid #4caf50",
    borderRadius: "16px",
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
    height: "24px",
  },

  "& .MuiChip-label": {
    padding: "0 6px",
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
  },
});

export const ChipInactive = styled(Chip)({
  "&.MuiChip-root": {
    backgroundColor: "transparent",
    color: "#00000080",
    border: "1px solid #00000080",
    borderRadius: "16px",
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
    height: "24px",
  },

  "& .MuiChip-label": {
    padding: "0 6px",
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
    color: "#00000080",
  },
});

export const Container = styled(Box)({
  background: "white",
  borderRadius: "4px",
  padding: "24px",
  marginTop: "15px",
  height: "auto",
  paddingBottom: "16px !important",
});

export const Header = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  padding: "8px 8px 8px 16px",
  marginBottom: "16px",
});

export const HeaderTitle = styled(Typography)({
  fontSize: "12px",
  fontWeight: 400,
  letterSpacing: "0.4px",
});

export const FormContainer = styled("div")({
  display: "flex",
  gap: "16px",
  marginBottom: "16px",
});

export const FieldContainer = styled("div")({
  display: "flex",
  gap: "16px",
  flex: 1,
});

export const StyledTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "4px",

    "& fieldset": {
      borderColor: "rgba(0, 0, 0, 0.23)",
    },
  },

  "& .MuiInputLabel-root": {
    fontSize: "12px",
    fontWeight: 400,
    letterSpacing: "0.15px",
    color: "rgba(0, 0, 0, 0.6)",
  },

  "& .MuiInputBase-input": {
    fontSize: "16px",
    fontWeight: 400,
    letterSpacing: "0.15px",
    color: "rgba(0, 0, 0, 0.87)",
  },

  "& .MuiFormHelperText-root": {
    fontSize: "12px",
    fontWeight: 400,
    letterSpacing: "0.4px",
    color: "rgba(0, 0, 0, 0.6)",
    lineHeight: "1.67",
  },
});

export const ActionsContainer = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  paddingTop: "16px",
  gap: "8px",
});

export const PrimaryButton = styled(Button)({
  height: "40px",
  backgroundColor: "#d33100",
  color: "#ffffff",
  borderRadius: "40px",
  fontSize: "15px",
  fontWeight: 500,
  letterSpacing: "0.46px",
  textTransform: "uppercase",
  boxShadow:
    "0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.2)",

  "&:hover": {
    backgroundColor: "#b02a00",
  },
});

export const SecondaryButton = styled(Button)({
  borderRadius: "40px",
  fontSize: "15px",
  height: "40px",
  fontWeight: 500,
  letterSpacing: "0.46px",
  textTransform: "uppercase",
  borderColor: "rgba(0, 0, 0, 0.5)",
  color: "#000000",

  "&:hover": {
    backgroundColor: "transparent",
    borderColor: "rgba(0, 0, 0, 0.7)",
  },
});

export const CancelButton = styled(SecondaryButton)({
  height: "40px",
});
